export default "__VITE_PUBLIC_ASSET__b6b6e47d__"